<div class="page-content">
  <!-- Page Header -->
  <div class="content-head">
    <!-- Not currently shown — duplicated the shared top header's title/subtitle.
    <div>
      <div class="eyebrow">STUDENT DIRECTORY</div>
      <h2>Students</h2>
      <p>Track readiness, applications, and placement progress for every student.</p>
    </div>
    -->
    <button type="button" class="primary-button" (click)="onAddStudent()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      Add student
    </button>
  </div>

  <!-- Students Panel -->
  <section class="panel">
    <!-- Not currently shown — panel heading.
    <div class="panel-heading">
      <h2>Student directory</h2>
    </div>
    -->

    <!-- Toolbar -->
    <div class="toolbar">
      <div class="search-box">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input
          type="text"
          [(ngModel)]="query"
          (ngModelChange)="onSearchInput()"
          placeholder="Search by name, email or ID..." />
      </div>

      <!-- Course/year filtering now comes from the shared header (Academic
      Year / Department selectors) instead of a second dropdown here.

      Not currently shown — no real readiness/placement-status data
      source exists on the backend yet (see StudentListItemDto). Filters
      stay commented alongside their columns below rather than deleted.
      <app-custom-select
        [value]="readinessFilter"
        [options]="readinessOptions"
        iconType="filter"
        (valueChange)="readinessFilter = $event">
      </app-custom-select>

      <app-custom-select
        [value]="statusFilter"
        [options]="statusOptions"
        iconType="filter"
        (valueChange)="statusFilter = $event">
      </app-custom-select>
      -->
    </div>

    <!-- Table -->
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Student Email</th>
            <th>Mobile Number</th>
            <th>Course / Degree</th>
            <th>Year of Passing</th>
            <th>City</th>
            <!-- Not currently shown — see toolbar comment above.
            <th>Readiness</th>
            <th>Credits Used</th>
            <th>Placement Status</th>
            -->
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let student of students"
            (click)="onViewStudent(student)"
            class="clickable-row">
            <td>
              <div class="person-cell">
                <div class="avatar table-avatar">{{ getInitials(student.first_name, student.last_name) }}</div>
                <strong>{{ student.first_name }} {{ student.last_name }}</strong>
              </div>
            </td>
            <td>{{ student.email }}</td>
            <td>{{ student.phone_number || '—' }}</td>
            <td>{{ student.course || '—' }}</td>
            <td>{{ student.year_of_passing || '—' }}</td>
            <td>{{ student.city || '—' }}</td>
            <!-- Not currently shown — see toolbar comment above.
            <td>
              <div class="readiness-cell">
                <span class="readiness-score">{{ student.score }}</span>
                <span class="readiness-label" [ngClass]="getReadinessClass(student.score)">
                  {{ getReadinessLabel(student.score) }}
                </span>
              </div>
            </td>
            <td>
              <strong>{{ student.creditsUsed }}</strong>
            </td>
            <td>
              <span class="status-pill" [ngClass]="getStatusClass(student.placementStatus)">
                {{ student.placementStatus }}
              </span>
            </td>
            -->
            <td>
              <button
                type="button"
                class="icon-button"
                (click)="$event.stopPropagation(); onViewStudent(student)"
                aria-label="View profile">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading && students.length === 0">
            <td colspan="7" class="empty-cell">No students match your criteria.</td>
          </tr>
          <tr *ngIf="isLoading">
            <td colspan="7" class="empty-cell">Loading students…</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="total > 0">
      <span>Showing {{ students.length }} of {{ total }} students</span>
      <div class="page-buttons">
        <button
          type="button"
          *ngFor="let p of pageNumbers"
          [class.current]="p === page"
          (click)="goToPage(p)">
          {{ p }}
        </button>
        <button type="button" aria-label="Next page" [disabled]="page >= totalPages" (click)="goToPage(page + 1)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    </div>
  </section>
</div>

<app-add-student-modal
  *ngIf="isAddStudentModalOpen"
  (close)="isAddStudentModalOpen = false"
  (studentAdded)="onStudentAdded()">
</app-add-student-modal>
